import React from "react";

interface ValidationErrorsProps {
  errors: string[];
}

export const ValidationErrors: React.FC<ValidationErrorsProps> = ({
  errors
}) => {
  if (errors.length === 0) return null;

  return (
    <div
      style={{
        marginBottom: "20px",
        padding: "15px",
        backgroundColor: "#f8d7da",
        borderRadius: "6px",
        border: "1px solid #f5c6cb"
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          color: "#721c24",
          marginBottom: "10px"
        }}
      >
        파일 업로드 오류:
      </div>
      {errors.map((error, index) => (
        <div key={index} style={{ color: "#721c24", fontSize: "14px" }}>
          • {error}
        </div>
      ))}
    </div>
  );
};
